import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import { FaEye } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import rutineAvatar from "../../assets/images/user/rutine-avatar.png";
import useStoredPermissions from "../useStoredPermissions";
import { DataTablePagination } from "../utils/dataTablePagination";
import { DropDownClients } from "../clients/dropDownClients";
import {
  getApiResponseMessage,
  getApiErrorMessage,
} from "../../utils/apiMessageHelper";
// Contexts
import { useNotification } from "../../contexts/NotificationContext";
import { useAuth } from "../../contexts/AuthContext";

export const ListRutines = () => {
  const { t } = useTranslation();
  const permissions = useStoredPermissions() || [];
  const { clientId } = useAuth();
  const { notify } = useNotification();

  // Check if user is Super Admin (clientId === 1)
  const isSuperAdmin = clientId === 1;

  //> Constants
  const history = useNavigate();

  const columns = [
    {
      Header: " ",
      columns: [
        {
          Header: "",
          accessor: "idw",
          Cell: (props) => {
            return (
              <img
                class="rounded-circle table-profile-icon"
                src={rutineAvatar}
                alt="activity-user"
              ></img>
            );
          },
        },
        { Header: "ID", accessor: "idRoutine" },
        { Header: t("routines.nameLabel"), accessor: "name" },
        { Header: t("routines.descriptionLabel"), accessor: "description" },
        {
          Header: "Detalle",
          accessor: "detalle",
          Cell: (props) => {
            return (
              <FaEye
                className="fa-table-icon"
                onClick={() =>
                  history(`/Rutine/${props.cell.row.original.idRoutine}`)
                }
              />
            );
          },
        },
        // {
        //     Header: 'Seleccionar', accessor: 'select',
        //     Cell: props => {
        //         return (<FaCheckDouble className="fa-table-icon" onClick={()=>setCurrentRutine(props.cell.row.original)}/>);
        //     }
        // },
      ],
    },
  ];

  //> States
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentRutine, setCurrentRutine] = useState([]);
  const [routineAssignments, setRoutineAssignments] = useState([]);
  const [validated, setValidated] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(
    isSuperAdmin ? null : clientId,
  );
  const [searchTerm, setSearchTerm] = useState("");

  const [showNewRutine, setShowNewRutine] = useState(false);
  const [newRutine, setNewRutine] = useState([]);
  const handleCloseNewRutine = () => setShowNewRutine(false);
  const handleShowNewRutine = () => setShowNewRutine(true);

  const handleClientChange = (selected) => {
    if (selected) {
      const newClientId = selected.idClient;
      // Allow setting to null when empty option is selected
      setSelectedClientId(newClientId);
      // Clear routines when empty option is selected
      if (newClientId === null) {
        setRows([]);
      }
    }
  };

  const [showEditRutine, setShowEditRutine] = useState(false);
  const handleCloseEditRutine = () => setShowEditRutine(false);
  const handleShowEditRutine = () => {
    setShowEditRutine(true);
    setRutineActiveEditSwitch(currentRutine.status === 1 ? true : false);
  };

  const [RutineActiveSwitch, setRutineActiveSwitch] = useState(true);
  const [RutineActiveEditSwitch, setRutineActiveEditSwitch] = useState(true);

  //> api calls
  async function getRutines() {
    try {
      const url = selectedClientId
        ? `${process.env.REACT_APP_API_URL}/api/v1/Routine/list/${selectedClientId}`
        : `${process.env.REACT_APP_API_URL}/api/v1/Routine/list`;

      const res = await Axios.get(url);
      if (res.data.length === 0) {
        setData((prev) => ({
          ...prev,
          message: t("routines.noRoutinesMessage"),
        }));
      }
      setRows(res.data.responseObject);
    } catch (e) {
      setData((prev) => ({
        ...prev,
        message: e.message,
      }));
    }
  }

  async function getRoutineAssignments(routineId) {
    try {
      // Obtener las asignaciones de la rutina
      const resAssignments = await Axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/Video/ByRoutine/${routineId}`,
      );

      const assignments = resAssignments.data.responseObject || [];

      // Si no hay asignaciones, retornar vacío
      if (assignments.length === 0) {
        setRoutineAssignments([]);
        return;
      }

      // Obtener videos tanto globales como del cliente seleccionado
      let allVideos = [];

      // Si hay un cliente seleccionado o el usuario no es super admin, obtener videos del cliente
      if (selectedClientId || (!isSuperAdmin && clientId)) {
        const clientIdToUse = selectedClientId || clientId;
        try {
          const resClientVideos = await Axios.get(
            `${process.env.REACT_APP_API_URL}/api/v1/Video/list/${clientIdToUse}`,
          );
          allVideos = [...(resClientVideos.data.responseObject || [])];
        } catch (err) {
          console.error("Error fetching client videos:", err);
        }
      }

      // Si es super admin o no encontramos el video, también buscar en videos globales
      if (isSuperAdmin || allVideos.length === 0) {
        try {
          const resGlobalVideos = await Axios.get(
            `${process.env.REACT_APP_API_URL}/api/v1/Video/list`,
          );
          const globalVideos = resGlobalVideos.data.responseObject || [];

          // Evitar duplicados comparando por idVideo
          const existingIds = new Set(allVideos.map((v) => v.idVideo));
          const newVideos = globalVideos.filter(
            (v) => !existingIds.has(v.idVideo),
          );
          allVideos = [...allVideos, ...newVideos];
        } catch (err) {
          console.error("Error fetching global videos:", err);
        }
      }

      // Mapear las asignaciones con los nombres y URLs de los videos
      const assignedVideos = assignments
        .map((assignment) => {
          const video = allVideos.find(
            (v) => v.idVideo === assignment.id_video,
          );
          return video
            ? {
                ...assignment,
                name: video.name,
                idStorage: video.idStorage,
              }
            : null;
        })
        .filter((v) => v !== null);

      setRoutineAssignments(assignedVideos);
    } catch (e) {
      console.error("Error fetching routine assignments:", e);
      setRoutineAssignments([]);
    }
  }

  async function deleteRutine() {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/Routine/${currentRutine.idRoutine}`,
      );

      if (res.status === 200) {
        const message =
          getApiResponseMessage(res) || t("routines.routineDeletedSuccess");
        notify(message, { type: "success" });
      }
    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      notify(errorMessage, { type: "error" });
    } finally {
      getRutines();
      setCurrentRutine(null);
      handleCloseDeleteRoutineConfirm();
    }
  }

  const handleNewRutinesubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      setValidated(false);

      try {
        newRutine.status = RutineActiveSwitch ? 1 : 0;
        const base = process.env.REACT_APP_API_URL;
        const postUrl = `${base}/api/v1/Routine${
          selectedClientId !== null ? `/${selectedClientId}` : ""
        }`;
        const res = await Axios.post(postUrl, newRutine);

        if (res.status === 200) {
          const message =
            getApiResponseMessage(res) || t("routines.routineAddedSuccess");
          notify(message, { type: "success" });
        }
      } catch (e) {
        const errorMessage =
          getApiErrorMessage(e) || t("routines.routineAddError");
        notify(errorMessage, { type: "error" });
      } finally {
        setShowNewRutine(false);
        getRutines();
        setNewRutine(null);
        setRutineActiveSwitch(true);
      }
    }
  };

  const handleEditRutinesubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      setValidated(false);
      try {
        const res = await Axios.put(
          `${process.env.REACT_APP_API_URL}/api/v1/Routine/${currentRutine.idRoutine}`,
          currentRutine,
        );

        if (res.status === 200) {
          const message =
            getApiResponseMessage(res) || t("routines.routineModifiedSuccess");
          notify(message, { type: "success" });
        }
      } catch (e) {
        const errorMessage =
          getApiErrorMessage(e) || t("routines.routineModifyError");
        notify(errorMessage, { type: "error" });
      } finally {
        setShowEditRutine(false);
        getRutines();
        setCurrentRutine(null);
        setRutineActiveSwitch(true);
      }
    }
  };

  const handleNewRutineChange = (object) => {
    const { name, value } = object.target;
    setNewRutine((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditRutineChange = (object) => {
    const { name, value } = object.target;
    setCurrentRutine((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [showDeleteRoutineConfirm, setShowDeleteRoutineConfirm] =
    useState(false);
  const handleCloseDeleteRoutineConfirm = () =>
    setShowDeleteRoutineConfirm(false);
  const handleShowDeleteRoutineConfirm = () =>
    setShowDeleteRoutineConfirm(true);

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo(null);
  };
  const handleShowVideoModal = (video) => {
    setSelectedVideo(video);
    setShowVideoModal(true);
  };

  //> lifecycles
  useEffect(() => {
    getRutines();
  }, [selectedClientId]);

  useEffect(() => {
    if (currentRutine?.idRoutine) {
      getRoutineAssignments(currentRutine.idRoutine);
    } else {
      setRoutineAssignments([]);
    }
  }, [currentRutine?.idRoutine]);

  // Filter rows based on search term (search in name and description)
  const filteredRows = rows.filter((row) => {
    const searchLower = searchTerm.toLowerCase();
    const nameMatch = row.name?.toLowerCase().includes(searchLower);
    const descriptionMatch = row.description
      ?.toLowerCase()
      .includes(searchLower);
    return nameMatch || descriptionMatch;
  });

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <Card>
            <Card.Header>
              <div className="d-flex justify-content-between align-items-center">
                <Card.Title as="h5">{t("routines.routinesManager")}</Card.Title>
                {isSuperAdmin && (
                  <div style={{ minWidth: "250px" }}>
                    <DropDownClients
                      value={selectedClientId}
                      onChange={handleClientChange}
                      className="form-control"
                    />
                  </div>
                )}
              </div>
            </Card.Header>
            <Card.Body>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <Button
                  id="btnLarge"
                  variant="primary"
                  onClick={handleShowNewRutine}
                  disabled={!permissions.includes("Add/Update Routine")}
                >
                  {t("common.add")}
                </Button>
              </div>

              {/* Search input */}
              <div style={{ marginBottom: "20px" }}>
                <Form.Control
                  type="text"
                  placeholder={t("routines.searchPlaceholder")}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <Row style={{ marginTop: "20px" }}>
                <Col xs={12} md={8}>
                  {filteredRows.length === 0 ? (
                    <div className="no-data">
                      {searchTerm
                        ? t("routines.noRoutinesFound")
                        : data?.message}
                    </div>
                  ) : (
                    <DataTablePagination
                      columns={columns}
                      data={filteredRows}
                      onRowClick={(selectedRow) =>
                        setCurrentRutine(selectedRow)
                      }
                      hiddenColumns={["idRoutine"]}
                    />
                  )}
                </Col>
                <Col xs={12} md={4}>
                  <Card>
                    <Card.Body className="p-0">
                      <div>
                        <div className="text-center project-main">
                          <img
                            className="img-fluid rounded-circle"
                            src={rutineAvatar}
                            alt="dashboard-user"
                          />
                          {/* Name */}
                          <div className="row m-t-30">
                            <div className="col-4">
                              <span>{t("routines.nameLabel")}:</span>
                            </div>
                            <div className="col-8">
                              <h6>{currentRutine?.name}</h6>
                            </div>
                          </div>
                          {/* Assignments */}
                          <div className="row m-t-30">
                            <div className="col-12">
                              <span className="mb-2 d-block">
                                <strong>
                                  {t("routines.assignmentsLabel")}
                                </strong>
                              </span>
                              <div
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                }}
                              >
                                {routineAssignments.length > 0 ? (
                                  <ul
                                    style={{
                                      listStyleType: "none",
                                      paddingLeft: "0",
                                      margin: 0,
                                    }}
                                  >
                                    {routineAssignments.map(
                                      (assignment, index) => (
                                        <li
                                          key={index}
                                          style={{
                                            marginBottom: "8px",
                                            fontSize: "0.9rem",
                                          }}
                                        >
                                          {assignment.idStorage ? (
                                            <span
                                              onClick={() =>
                                                handleShowVideoModal(assignment)
                                              }
                                              style={{
                                                color: "#007bff",
                                                textDecoration: "none",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                                cursor: "pointer",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.textDecoration =
                                                  "underline")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.textDecoration =
                                                  "none")
                                              }
                                            >
                                              <span
                                                style={{ fontSize: "1.1rem" }}
                                              >
                                                ▶
                                              </span>
                                              {assignment.name ||
                                                t("routines.videoWithoutName")}
                                            </span>
                                          ) : (
                                            <span style={{ color: "#666" }}>
                                              {assignment.name ||
                                                t(
                                                  "routines.videoWithoutName",
                                                )}{" "}
                                              {t("routines.videoWithoutUrl")}
                                            </span>
                                          )}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                ) : (
                                  <p
                                    style={{
                                      fontSize: "0.85rem",
                                      color: "#666",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {t("routines.noAssignmentsText")}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className="row m-t-30"
                            style={{
                              visibility:
                                currentRutine?.idRoutine !== null
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            <div className="col-6 p-r-0">
                              <Link
                                className="btn btn-primary  text-uppercase btn-block"
                                onClick={handleShowEditRutine}
                              >
                                {t("common.edit")}
                              </Link>
                            </div>
                            <div className="col-6">
                              <Button
                                onClick={handleShowDeleteRoutineConfirm}
                                className="btn text-uppercase border btn-block btn-outline-danger"
                                disabled={
                                  !permissions.includes("Delete Routine")
                                }
                              >
                                {t("common.delete")}
                              </Button>
                            </div>
                          </div>
                        </div>
                        <div className="border-top" />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <!-- Modal create new Rutine--> */}
      <Modal show={showNewRutine} onHide={handleCloseNewRutine}>
        <Form
          className="addForm"
          onSubmit={handleNewRutinesubmit}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("routines.addNewRoutineModal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="justify-content-md-center">
              {/* Name */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("routines.nameLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={3}
                  autoFocus
                  type="text"
                  name="name"
                  value={newRutine?.name || ""}
                  placeholder={t("routines.nameLabel")}
                  onChange={handleNewRutineChange}
                />
              </InputGroup>
              {/* Description */}
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  {t("routines.descriptionLabel")}
                </InputGroup.Text>
                <Form.Control
                  required
                  minLength={2}
                  autoFocus
                  type="text"
                  name="description"
                  value={newRutine?.description || ""}
                  placeholder={t("routines.descriptionLabel")}
                  onChange={handleNewRutineChange}
                />
              </InputGroup>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseNewRutine}>
              {t("common.close")}
            </Button>
            <Button variant="primary" type="submit">
              {t("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* <!-- Modal create Edit Rutine--> */}
      <Modal show={showEditRutine} onHide={handleCloseEditRutine}>
        <Form
          className="addForm"
          onSubmit={handleEditRutinesubmit}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("routines.editRoutineModal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="justify-content-md-center">
              {/* Name */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("routines.nameLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={3}
                  autoFocus
                  type="text"
                  name="name"
                  value={currentRutine?.name || ""}
                  placeholder={t("routines.nameLabel")}
                  onChange={handleEditRutineChange}
                />
              </InputGroup>
              {/* Email */}
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  {t("routines.descriptionLabel")}
                </InputGroup.Text>
                <Form.Control
                  required
                  minLength={2}
                  autoFocus
                  type="text"
                  name="description"
                  value={currentRutine?.description || ""}
                  placeholder={t("routines.descriptionLabel")}
                  onChange={handleEditRutineChange}
                />
              </InputGroup>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditRutine}>
              {t("common.close")}
            </Button>
            <Button variant="primary" type="submit">
              {t("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* <!-- Modal delete Routine--> */}
      <Modal
        show={showDeleteRoutineConfirm}
        onHide={handleCloseDeleteRoutineConfirm}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("common.confirmDeleteTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("routines.deleteRoutineConfirmMessage")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteRoutineConfirm}>
            {t("common.cancel")}
          </Button>
          <Button variant="danger" onClick={deleteRutine}>
            {t("common.delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <!-- Modal Video Player--> */}
      <Modal
        show={showVideoModal}
        onHide={handleCloseVideoModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.name || "Video"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {selectedVideo?.idStorage && (
            <video
              controls
              autoPlay
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "70vh",
                backgroundColor: "#000",
              }}
            >
              <source src={selectedVideo.idStorage} type="video/mp4" />
              {t("routines.browserNotSupported")}
            </video>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseVideoModal}>
            {t("common.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
